var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapseRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 4.5L15.5 20.5M4.5 6.5C4.5 5.96957 4.71071 5.46086 5.08579 5.08579C5.46086 4.71071 5.96957 4.5 6.5 4.5L18.5 4.5C19.0304 4.5 19.5391 4.71072 19.9142 5.08579C20.2893 5.46086 20.5 5.96957 20.5 6.5L20.5 18.5C20.5 19.0304 20.2893 19.5391 19.9142 19.9142C19.5391 20.2893 19.0304 20.5 18.5 20.5L6.5 20.5C5.96956 20.5 5.46086 20.2893 5.08578 19.9142C4.71071 19.5391 4.5 19.0304 4.5 18.5L4.5 6.5Z",
    stroke: "#7575A8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10.5L11.5 12.5L9.5 14.5",
    stroke: "#7575A8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseRight);
export default __webpack_public_path__ + "static/media/collapse-right.5a74dd9222f8f81c4f89f4c929de4ec7.svg";
export { ForwardRef as ReactComponent };